var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"phone"},[(!_vm.checkPhoneValidity(_vm.value))?_c('span',[_vm._v(_vm._s(_vm.value))]):_vm._l((_vm.fragment),function(i,index){return _c('span',{key:index,staticClass:"fragment"},[_vm._v(_vm._s(i))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }